require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./lilo-lilo-rocks.json") })
        }
      }, "path---lilo-lilo-rocks");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---lilo-lilo-rocks!./.cache/json/lilo-lilo-rocks.json
// module id = 319
// module chunks = 231608221292675